import { type PropsWithChildren } from 'react'
import { type ResponsiveStyleValue } from '@mui/system'
import { type BaseProps } from '../../types'
import { type StackSxProps } from './types'
import { Stack } from './Stack'

type Props = PropsWithChildren<{
  /**
   * Space between the elements
   * @default 2
   */
  gap?: number | ResponsiveStyleValue<string | number>

  onClick?: () => void
}> &
  BaseProps<HTMLDivElement, never, StackSxProps>

export const StackColumn = ({ children, gap = 2, sx, ...rest }: Props) => (
  <Stack direction="column" sx={{ ...sx, gap, width: sx?.width ?? '100%' }} {...rest}>
    {children}
  </Stack>
)
